import { forwardRef } from 'react';
import useCachedSpecialitiesList from '@src/adapters/hooks/specialities/useCachedSpecialitiesList';
import IdNameDto from '@src/adapters/dto/shared/IdNameDto';
import GenericAutoComplete from './GenericAutoComplete';

interface Props {
  label: string;
  required?: boolean;
  selected?: IdNameDto;
  selectedId?: string;
  selection?: (selectedItem: any | null) => void;
}

const SpecialityAutoComplete = forwardRef<HTMLDivElement, Props>(
  function SpecialityAutoComplete(
    { label, required = false, selected, selection, selectedId },
    ref
  ) {
    const { getList } = useCachedSpecialitiesList();

    return (
      <GenericAutoComplete
        ref={ref}
        label={label}
        required={required}
        fetchData={getList}
        itemSelected={selection}
        updatedItem={selected}
        selectedId={selectedId}
        sx={{ width: '100%' }}
        initialfilter=""
      />
    );
  }
);

export default SpecialityAutoComplete;
